import { toast } from "sonner";
import request from "../../helpers/request";
export const solicitarAtivacao2FA = async () => {
  const url = `${process.env.REACT_APP_API}/Usuario/Ativar2FA`;
  const result = await request({ url, method: "POST", noProtect: false });

  if (result.status === 200) {
    toast.success("Dados para ativação do 2FA gerados!");
    return result.data;
  } else {
    toast.error("Falha ao iniciar a ativação do 2FA.");
    throw new Error(result.data?.message || "Erro desconhecido ao ativar 2FA.");
  }
};

export const confirmarAtivacao2FA = async (code: string, secretKey: string) => {
  const url = `${process.env.REACT_APP_API}/Usuario/ConfirmarAtivacao2FA?code=${code}&secretKey=${secretKey}`;

  try {
    const result = await request({
      url,
      method: "POST",
      noProtect: false,
    });

    return result.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      "Código de verificação inválido.";
    throw new Error(message);
  }
};